import { MessagingBackend } from "@whatslly/commons/messagingBackend";
import type { WebScriptCommandsTypes } from "@whatslly/commons/webScriptCommands";
import { WebScriptCommands, WEB_SCRIPT_COMMANDS_PREFIX } from "@whatslly/commons/webScriptCommands";
export const webScriptBackend = new MessagingBackend<WebScriptCommandsTypes>(WebScriptCommands, WEB_SCRIPT_COMMANDS_PREFIX);
const handler = webScriptBackend.getHandler((event: MessageEvent) => ({ request: event.data, respond: event.source?.postMessage }));
window.addEventListener?.("message", handler);
